import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import {
  FUND_ALLOCATIONS_BY_MD_DEFAULT_ERROR_MESSAGE,
  FUND_ALLOCATIONS_BY_MD_QUERY_KEY,
} from 'common/constants/services/funds';
import { FundService } from 'services';
import { throwError } from 'utillities';
import {
  GetFundAllocationsByMDHook,
  GetFundAllocationsByMDParams,
  GetFundAllocationsByMDResponse,
  UseGetFundAllocationsByMD,
} from './types';

const getFundAllocationsByMD = async (params: GetFundAllocationsByMDParams) => {
  const { fundId, measurementDateId } = params;

  if (isNil(fundId) && isNil(measurementDateId)) return null;

  const fundService = new FundService();

  try {
    const fundAlloactions = (await fundService.getFundAllocationsByMd(
      fundId,
      measurementDateId
    )) as GetFundAllocationsByMDResponse;

    if (!fundAlloactions) return throwError(FUND_ALLOCATIONS_BY_MD_DEFAULT_ERROR_MESSAGE);

    return fundAlloactions;
  } catch (error) {
    return throwError(FUND_ALLOCATIONS_BY_MD_DEFAULT_ERROR_MESSAGE);
  }
};

const useGetFundAllocationsByMD: UseGetFundAllocationsByMD = params => {
  const { fund, measurementDate, shouldQueryAutomatically = true } = params;

  const fundId = fund?.id;
  const measurementDateId = measurementDate?.id;

  const { data, error, isError, isFetching, isLoading, refetch } = useQuery<GetFundAllocationsByMDHook['data'], Error>({
    enabled: !isNil(fundId) && !isNil(measurementDateId) && shouldQueryAutomatically,
    queryFn: () => getFundAllocationsByMD({ fundId, measurementDateId }),
    queryKey: [FUND_ALLOCATIONS_BY_MD_QUERY_KEY, fundId, measurementDateId],
  });

  return {
    data,
    error,
    isError,
    isFetching,
    isLoading,
    refetch,
  };
};

export default useGetFundAllocationsByMD;
